const responseNovelties = {
    "payload": {
        "items": [
            {
                "newsUpdateId": 5,
                "title": "prueba tipos novedad",
                "functionality": "Pizarra",
                "startDate": "2025-09-10",
                "endDate": "2025-09-11",
                "status": "Visible",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-pruebatiposnovedad.jpg",
                "message": "interesante",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            },
            {
                "newsUpdateId": 8,
                "title": "final",
                "functionality": "Pizarra",
                "startDate": "2025-09-10",
                "endDate": "2025-09-11",
                "status": "Oculto",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-final.jpg",
                "message": "interesante",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            },
            {
                "newsUpdateId": 10,
                "title": "final",
                "functionality": "Pizarra",
                "startDate": "2025-09-10",
                "endDate": "2025-09-11",
                "status": "Oculto",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-final.jpg",
                "message": "interesante",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            },
            {
                "newsUpdateId": 11,
                "title": "final",
                "functionality": "Pizarra",
                "startDate": "2025-09-10",
                "endDate": "2025-09-11",
                "status": "Visible",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-final.jpg",
                "message": "interesante",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            },
            {
                "newsUpdateId": 14,
                "title": "final prueba",
                "functionality": "Pizarra",
                "startDate": "2025-09-10",
                "endDate": "2025-09-11",
                "status": "Visible",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-finalprueba.jpg",
                "message": "interesante",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            },
            {
                "newsUpdateId": 7,
                "title": "actualizacion final",
                "functionality": "Marketplace",
                "startDate": "2025-09-01",
                "endDate": "2025-10-01",
                "status": "Visible",
                "imageUrl": "https://ibliss-icons-dev.s3.amazonaws.com/news_feed/1-actualizacionfinal.jpg",
                "message": "update",
                "companies": [
                    {
                        "companyId": 1,
                        "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo"
                    }
                ]
            }
        ],
        "isMax": false
    }
}

const responseNovelty = {
    status: 200,
    data: {
        "payload": {
            "headers": {},
            "body": {
                "payload": {
                    "newsUpdateId": 62
                }
            },
            "statusCodeValue": 201,
            "statusCode": "CREATED"
        }
    }
}

const responseNoveltyUpdate = {
    status: 200,
    data: {
        "payload": {
            "headers": {},
            "body": {
                "payload": {
                    "newsUpdateId": 53
                }
            },
            "statusCodeValue": 200,
            "statusCode": "OK"
        }
    }
}

const responseNoveltyDelete = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Novedad eliminada con exito'
        }
    }
}

export const service = {
    getListNovelties: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseNovelties }), 1000);
    }),
    postCreateNovelty: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseNovelty }), 1000);
    }),
    postUpdateNovelty: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseNoveltyUpdate }), 1000);
    }),
    getDeleteNovelty: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseNoveltyDelete }), 1000);
    })
}